import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgHouseFilled = function SvgHouseFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8153 2.34689C12.7771 1.4345 11.2229 1.4345 10.1847 2.34689L3.93468 7.83932C3.34056 8.36143 3 9.11408 3 9.90502V18.2501C3 19.7689 4.23122 21.0001 5.75 21.0001H8.16057C9.12707 21.0001 9.91057 20.2166 9.91057 19.2501V17.0001C9.91057 15.8955 10.806 15.0001 11.9106 15.0001H12C13.1046 15.0001 14 15.8955 14 17.0001V19.2501C14 20.2166 14.7835 21.0001 15.75 21.0001H18.25C19.7688 21.0001 21 19.7689 21 18.2501V9.90502C21 9.11408 20.6594 8.36143 20.0653 7.83932L13.8153 2.34689Z"
  })));
};

export { SvgHouseFilled as ReactComponent };
//# sourceMappingURL=house-filled.svg.js.map
